<script>
    import Spinner from '../../components/Spinner.svelte';
	import UnathContext from '../../layouts/UnathContext.svelte';
	import { navigate } from 'svelte-routing';
	import queryString from 'query-string';
	import firebase from '../../firebase';
	import { currentUser } from '../../stores/currentUser';

	const params = queryString.parse(window.location.search);
	const returnUrl = params.returnUrl || '/';
	let email = params.email || '';
	let password = '';
	let message = params.error ? { type: 'error', text: params.error } : null;
	let promise;

	const waitUntilSignedIn = async () => {
		let unsubscribe;
		await new Promise(resolve => {
			unsubscribe = currentUser.subscribe(user => {
				if (user && !user.userNotFound) {
					resolve();
				}
			})
		});
		unsubscribe();
	}

	const signIn = () => {
		message = null;
		promise = (async () => {
			await firebase.auth().signInWithEmailAndPassword(email, password);
			await waitUntilSignedIn();
			navigate(returnUrl);
        })().catch(error => message = { type: 'error', text: getErrorMessage(error) });
	}

	const getErrorMessage = ({ code, message }) => {
		switch (code) {
			case "auth/invalid-email":
				return message;
			case "auth/user-not-found":
				return "User not found."
			case "auth/wrong-password":
				return "Password is incorrect."
			default:
				console.log(code, message);
				return "";
		}
	}
</script>

<UnathContext title="Sign in" on:enterPressed={signIn}>
	<div class="modal">
		<div class="modal__box modal__box--sm">
			<div class="modal__header">
				Sign in to Eastwood 45
			</div>
			<div class="modal__body layout">
				<div class="layout__column">
					<div class="layout__item">
						<input class="form__input" type="text" placeholder="Email" bind:value={email} />
					</div>
					<div class="layout__item">
						<input class="form__input" type="password" placeholder="Password" bind:value={password} />
					</div>
					{#if message}
						<div class="layout__item {message.type}-message">{message.text}</div>
					{/if}
					<div class="layout__row layout__row--collapsable layout__row--space-between">
						<div class="layout__item">
							<div
								class="form__button form__button--subtle"
								on:click={() => navigate(`/auth/send-reset-email${email ? `?email=${encodeURIComponent(email)}` : ""}`)}>
								Forgotten password?
							</div>
						</div>
						<div class="layout__row layout__row--right">
							<div class="layout__item layout__item--cosy">
								<div
									class="form__button form__button--secondary"
									on:click={() => navigate(`/auth/sign-up${email ? `?email=${encodeURIComponent(email)}` : ""}`)}>
									Sign up
								</div>
							</div>
							<div class="layout__item">
								{#await promise}
									<div class="form__button form__button--disabled"><Spinner />Sign in</div>
								{:then result}
									<div class="form__button" on:click={signIn}>Sign in</div>
								{/await}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</UnathContext>